<template>
  <div style="height: 100%">
    <div class="buttonBox" style='justify-content: space-between;'>
      <div style="margin-left: -4px;">
        <div class="chooseButton searchButton" @click="add" v-if="MenuRoleList.indexOf('46')>=0"><i
          class="el-icon-circle-plus-outline"></i>{{ $t('btn_14') }}
        </div>
        <div class="chooseButton searchButton" @click="edit" v-if="MenuRoleList.indexOf('47')>=0"><i
          class="el-icon-edit-outline"></i>{{ $t('btn_15') }}
        </div>
        <div class="chooseButton deleteButton" @click="remove" v-if="MenuRoleList.indexOf('48')>=0"><i
          class="el-icon-delete"></i>{{ $t('btn_16') }}
        </div>
        <div class="chooseButton memberButton" @click="copyRole" v-if="MenuRoleList.indexOf('46')>=0"><i
          class="el-icon-document-copy"></i>{{ $t('btn_55') }}
        </div>
        <div class="chooseButton memberButton" @click="member" v-if="MenuRoleList.indexOf('46')>=0"><i
          class="el-icon-user"></i>{{ $t('btn_56') }}
        </div>
      </div>
      <el-checkbox v-model='expand' @change='list' style='font-size:14px;font-weight:600;color:#3fb393;'>
        {{ $t('btn_58') }}
      </el-checkbox>
    </div>
    <div class="tableMin">
      <el-table :empty-text="$t('label_357')" :data="tableData" @current-change="tableCurrentChange" ref="singleTable"
                highlight-current-row
                border style="width: 100%;margin: 10px 0" :height="tableHeight"
                :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
        <el-table-column :label="$t('label_369') + '.'" header-align="center" align="center" type="index" width="50">
        </el-table-column>
        <el-table-column :label="$t('label_22')">
          <template slot-scope="scope">
            <div @dblclick='nameClick(scope.row)'>
              {{ formatRoleName(scope.row.roleName) }}<br>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('label_24')">
          <template slot-scope="scope">
            <div v-if='scope.row.memberNames!=null'>
              <div v-if="scope.row.memberNames.split(',').length<=5">
                <div v-for='(item1,index1) in scope.row.memberNames.split(",")' :key="index1"
                     class='contactRow'>
                  <img src="../../../assets/img/member.png"><span>{{ item1 }}</span>
                </div>
              </div>
              <div v-if="scope.row.memberNames.split(',').length>5">
                <el-tooltip effect="light" placement="bottom-start">
                  <div slot="content">
                    <div v-for='(item2,index2) in scope.row.memberNames.split(",")' :key="index2"
                         class='contactRow'>
                      <img src="../../../assets/img/member.png"><span>{{ item2 }}</span>
                    </div>
                  </div>
                  <div class='contactRow'
                       style="max-width:200px;overflow:hidden;text-overflow:ellipsis;-o-text-overflow:ellipsis;white-space:nowrap;">
                    <img src="../../../assets/img/member.png"><span>{{ scope.row.memberNames }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('label_412')" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.state" :active-value='1' :inactive-value='0' :active-text="$t('label_10')"
                       :inactive-text="$t('label_6')" active-color="#3fb393" inactive-color="#ff3300"
                       @change="stateChange(scope.row)"
                       :disabled="!(MenuRoleList.indexOf('46')>=0||MenuRoleList.indexOf('47')>=0||MenuRoleList.indexOf('48')>=0)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="version != 1" :label="$t('label_929')" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.checkAllOrNot" :active-value='1' :inactive-value='0' :active-text="$t('label_471')"
                       :inactive-text="$t('label_474')"
                       active-color="#3fb393" inactive-color="#ff3300" @change="checkAllOrNotChange(scope.row)"
                       :disabled="!(MenuRoleList.indexOf('46')>=0||MenuRoleList.indexOf('47')>=0||MenuRoleList.indexOf('48')>=0)">
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('label_501')" align="center">
          <template slot-scope="scope">
            <el-button @click="moveUp(scope.row, scope.$index)" :disabled="upDisabled(scope.$index)"
                       type="text" size="small" style="font-size: 20px"><i class="el-icon-arrow-up"></i>
            </el-button>
            <el-button @click="moveDown(scope.row, scope.$index)" :disabled="downDisabled(scope.$index)"
                       type="text" size="small" style="font-size: 20px"><i class="el-icon-arrow-down"></i>
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <el-dialog v-loading="saveLoading" :visible.sync="dialogVisible" :title="dialogTitle" :before-close="dialogClose" append-to-body
               v-dialogDrag
               :close-on-click-modal='false' width="800px" top="5%" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <el-row class="dialogMes">
          <el-col :span="1"></el-col>
          <el-col :span="3">{{ $t('label_720') }}</el-col>
          <el-col :span="20">
            <div class="treeNoChoose">
              <div class="selectSpot2" style='height: 100%;'>
                <el-tree :load="loadTree" @check="treeCheck" v-if="showTree" ref="tree"
                         show-checkbox check-strictly lazy :props="treeProps" :accordion='true' node-key="id"
                         :default-expanded-keys="expandedKeys" :render-after-expand='false'>
                  <div class="custom-tree-node" slot-scope="{node,data}">
                    <div class="title" style="width:250px;position:relative;display: flex">
                      <p
                        style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
                        {{ data.name }}
                      </p>
                    </div>
                  </div>
                </el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="dialogMes">
          <el-col :span="1" style='color:#ff0000;text-align: right;padding-right: 5px;'>*</el-col>
          <el-col :span="3">{{ $t('label_297') }}</el-col>
          <el-col :span="20">
            <el-input v-model="formModel.roleName"></el-input>
          </el-col>
        </el-row>
        <el-row class="dialogMes">
          <el-col :span="1"></el-col>
          <el-col :span="3">{{ $t('label_733') }}</el-col>
          <el-col :span="20">
            <el-input v-model="formModel.duty" type="textarea" :rows="2">
            </el-input>
          </el-col>
        </el-row>
        <el-row class="dialogMes">
          <el-col :span="1"></el-col>
          <el-col :span="3">{{ $t('label_20') }}</el-col>
          <el-col :span="20">
            <div style='height:400px;overflow-y: scroll;'>
              <el-checkbox-group v-model="formModel.menuIds">
								<span v-for='(menu,index) in allMenus' :key="index">
									<p v-if='menu.type!=99' style='height:1px;'></p>
									<span :class='"menuName"+menu.type+" folder"+index'>
										<!-- <el-checkbox :label="menu.id">
											<span :class="'menuText'+menu.type">{{menu.name}}
											</span>
										</el-checkbox>
										<el-button @click="checkAll(menu)" v-if="menu.orderNum % 10000==0"
											class='checkAll'>
											{{allChecked[menu.orderNum/10000]?$t('label_282'):$t('btn_26')}}
										</el-button> -->
										<div v-if="menu.orderNum % 10000==0" @click.stop="enable($event,menu)">
											<el-checkbox :label="'all_'+index" style="font-weight: bold;">
												{{ $t('btn_26') }}
											</el-checkbox>
										</div>
										<el-checkbox @change="roleChangeHandle" :label="menu.id">
											<span :class="'menuText'+menu.type">{{ $t(menu.name)}}</span>
										</el-checkbox>
									</span>
								</span>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
				<div @click="save" class="chooseButton sendButton">{{ $t('btn_13') }}</div>
			</span>
    </el-dialog>

    <el-dialog v-loading="saveLoading" :visible.sync="memberDialogVisible" :title="$t('btn_56')" :before-close="memberDialogClose"
               append-to-body
               :close-on-click-modal='false' width="800px" top="5%" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <el-tag v-for="(item, index) in formModel.memberNames" :key="index" @close="tagClose(item)" closable
                effect="plain" color='#ffffff' :disable-transitions="true">
          {{ item }}
        </el-tag>
        <el-autocomplete :fetch-suggestions="querySearchAsync" @select="handleSelect" value-key='fullName'
                         v-model="inputValue" v-if="inputVisible" ref="saveTagInput" :placeholder="$t('input_46')"
                         :trigger-on-focus="false" size="small">
        </el-autocomplete>
        <el-button v-else @click="showInput" size="small">+</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
				<div @click="saveMember" class="chooseButton sendButton">{{ $t('btn_13') }}</div>
			</span>
    </el-dialog>

    <el-dialog :visible.sync="viewDialogVisible" :title="$t('label_59')" append-to-body custom-class="dialogBox"
               top="5%">
      <div style='width:90%;margin-left:5%;'>
				<span style='font-size: 20px;'><span
          style='margin-right:10px;font-weight: 600;'>{{ viewModel.roleName }}</span>{{ parentName }}</span>
        <div>{{ viewModel.duty }}</div>
        <div class='viewDialogTable'>
          <label class='viewDialogLabel'>{{ $t('label_20') }}</label>
          <div style='height:400px;overflow-y: scroll;'>
            <el-checkbox-group v-model="viewModel.menuIds">
							<span v-for='(menu,index) in allMenus' :key="index">
								<p v-if='menu.type!=99' style='height:1px;'></p>
								<span :class='"menuName"+menu.type+" folder"+index'>
									<el-checkbox :label="menu.id" disabled>
										<span :class="'menuText'+menu.type">{{ $t(menu.name) }}</span>
									</el-checkbox>
								</span>
							</span>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-loading="saveLoading" :visible.sync="copyDialogVisible" :title="$t('btn_55')" append-to-body :close-on-click-modal='false'
               width="800px" top="5%" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <el-row class="dialogMes">
          <el-col :span="1"></el-col>
          <el-col :span="3">{{ $t('label_720') }}</el-col>
          <el-col :span="20">
            <div class="treeNoChoose">
              <div class="selectSpot2" style='height: 100%;'>
                <el-tree :load="loadTree" v-if="showTree" ref="treeCopy" show-checkbox check-strictly
                         lazy :props="treeProps" :accordion='true' node-key="id"
                         :render-after-expand='false'>
                  <div class="custom-tree-node" slot-scope="{node,data}">
                    <div class="title" style="width:250px;position:relative;display: flex">
                      <p
                        style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
                        {{ data.name }}
                      </p>
                    </div>
                  </div>
                </el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="dialogMes">
          <el-col :span="1" style='color:#ff0000;text-align: right;padding-right: 5px;'>*</el-col>
          <el-col :span="3">{{ $t('label_27') }}</el-col>
          <el-col :span="20">
            <el-input v-model="copiedName"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
				<div @click="saveCopy" class="chooseButton sendButton">{{ $t('btn_13') }}</div>
			</span>
    </el-dialog>
  </div>
</template>
<script>
import utils from '@/utils/utils';
import organizationTabJs from "@/assets/js/system/organizationTab.js";
import menuTabJs from "@/assets/js/system/menuTab.js";
import userJs from "@/assets/js/system/user.js";

export default {
  name: "menuTab",
  components: {},
  data() {
    return {
      saveLoading: false,
      copyDialogVisible: false,
      copiedName: '',
      nodeId: '',
      hierarchy: '',
      expand: true,
      //table
      tableData: [],
      MenuRoleList: [],
      currentRow: {},
      tableHeight: 0,
      //edit dialog
      dialogVisible: false,
      dialogTitle: this.$t('btn_14'),
      formModel: {
        organizationId: '',
        roleName: "",
        duty: '',
        menuIds: [],
        menuNames: [],
        memberNames: [],
        memberIds: [],
        roleId: '',
      },
      treeProps: {
        label: 'name',
      },
      expandedKeys: [],
      showTree: true,
      allMenus: [],
      allChecked: [false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      //memberDialog
      memberDialogVisible: false,
      inputVisible: false,
      inputValue: '',
      //viewDialog
      viewDialogVisible: false,
      viewModel: {
        roleName: "",
        duty: '',
        menuIds: [],
      },
      parentName: '',
      version: ''
    }
  },
  methods: {
    copyRole() {
      if (Object.keys(this.currentRow).length > 0) {
        this.copyDialogVisible = true;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    saveCopy() {
      this.saveLoading = true;
      if (this.$refs.treeCopy.getCheckedKeys().length > 1) {
        utils.messageAlert(this.$t('msg_29'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      if (this.copiedName == '') {
        utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      menuTabJs.copy({
        roleId: this.currentRow.roleId,
        roleName: this.copiedName,
        organizationId: this.$refs.treeCopy.getCheckedKeys()[0]
      }).then((response) => {
        if (response.data.code == "1") {
          if (response.data.data == 1) {
            utils.messageAlert(this.$t('label_68'), this.$t('label_358'), this.$t('label_100'));
          } else {
            this.copyDialogVisible = false;
            this.$message.success(this.$t('msg_17'))
            // utils.messageAlert(this.$t('msg_17'), this.$t('label_358'), this.$t('label_100'));
            this.copiedName = '';
            this.$refs.treeCopy.setCheckedKeys([]);
            this.list();
          }
        } else {
          utils.messageAlert(response.data.message, this.$t('label_358'), this.$t('label_100'));
        }
        this.saveLoading = false;
      }).catch((response) => {
        this.saveLoading = false;
        console.log(response)
      })
    },
    //从属于
    loadTree(node, resolve) {
      if (node.level === 0) {
        let child = this.getChildren(0);
        child.then((res) => {
          resolve(res);
        });
      } else {
        let child = this.getChildren(node.data.id);
        child.then((res) => {
          if (res == "") {
            return resolve([]);
          } else {
            resolve(res);
          }
        });
      }
    },
    async getChildren(pid) {
      let childArr = [];
      await organizationTabJs.getChildren({
        pid: pid
      }).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          childArr = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return childArr;
    },
    treeCheck(data, checked, indeterminate) {
      this.$refs.tree.setCheckedKeys([data.id]);
      this.formModel.organizationId = data.id;
    },
    reloadTree() {
      this.showTree = false;
      this.$nextTick(function () {
        this.showTree = true;
      })
    },

    add() {
      this.formModel.organizationId = this.nodeId;
      this.dialogVisible = true;
      this.dialogTitle = this.$t('btn_14');
      this.$nextTick(_ => {
        this.$refs.tree.setCurrentKey(this.nodeId);
        this.$refs.tree.setCheckedKeys([this.nodeId]);
      });
      this.allChecked = [false, false, false, false, false, false, false, false, false, false, false, false,
        false
      ];
    },
    edit() {
      if (Object.keys(this.currentRow).length > 0) {
        this.formModel.organizationId = this.currentRow.organizationId;
        let index = this.currentRow.roleName.lastIndexOf('/');
        if (index == -1) {
          this.formModel.roleName = this.currentRow.roleName;
        } else {
          this.formModel.roleName = this.currentRow.roleName.substr(index + 1);
        }
        this.formModel.duty = this.currentRow.duty;
        if (this.currentRow.menuIds != null) {
          this.formModel.menuIds = this.currentRow.menuIds.split(',');
        }
        this.formModel.menuNames = this.currentRow.menuNames;
        if (this.currentRow.memberIds != null) {
          this.formModel.memberIds = this.currentRow.memberIds.split(',');
          this.formModel.memberNames = this.currentRow.memberNames.split(',');
        }
        this.formModel.roleId = this.currentRow.roleId;
        this.dialogTitle = this.$t('btn_15');
        this.dialogVisible = true;
        this.$nextTick(_ => {
          this.expandedKeys.push(this.currentRow.organizationId);
          this.$refs.tree.setCurrentKey(this.currentRow.organizationId);
          this.$refs.tree.setCheckedKeys([this.currentRow.organizationId]);
        });
        this.allChecked = [false, false, false, false, false, false, false, false, false, false, false, false,
          false
        ];
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    dialogClose() {
      this.formModel = {
        organizationId: '',
        roleName: "",
        duty: '',
        menuIds: [],
        menuNames: [],
        memberNames: [],
        memberIds: [],
        roleId: '',
      };
      this.$refs.tree.setCheckedKeys([]);
      this.dialogVisible = false;
    },
    enable(e, menu) {
      if (e.target.tagName !== 'INPUT') return
      this.checkAll(menu)
    },
    checkAll(menu) {
      let orderNum1 = menu.orderNum;
      let orderNum2 = orderNum1 + 10000;
      let checkIndex = orderNum1 / 10000;
      this.allChecked[checkIndex] = this.allChecked[checkIndex] ? false : true;
      for (let i = 0; i < this.allMenus.length; i++) {
        if (this.allMenus[i].orderNum >= orderNum1 && this.allMenus[i].orderNum < orderNum2) {
          if (this.allChecked[checkIndex]) {
            if (!this.formModel.menuIds.includes(this.allMenus[i].id)) {
              this.formModel.menuIds.push(this.allMenus[i].id);
            }
          } else {
            let index = this.formModel.menuIds.indexOf(this.allMenus[i].id);
            this.formModel.menuIds.splice(index, 1);
          }
        }
      }
    },
    save() {
      this.saveLoading = true;
      if (this.formModel.roleName == '') {
        utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      this.$set(this.formModel, 'state', 1);
      this.$set(this.formModel, 'valid', 0);
      let ids = [];
      this.formModel.menuIds.forEach(function (e) {
        if (e.indexOf("_") < 0) {
          ids.push(e);
        }
      });
      this.formModel.menuIds = ids;
      if (this.dialogTitle == this.$t('btn_14')) {
        menuTabJs.add(this.formModel).then((response) => {
          if (response.data.code == "1") {
            this.dialogVisible = false;
            this.$message.success(this.$t('msg_18'))
            // utils.messageAlert(this.$t('msg_18'), this.$t('label_358'), this.$t('label_100'));
            this.formModel = {
              organizationId: '',
              roleName: "",
              duty: '',
              menuIds: [],
              menuNames: [],
              memberNames: [],
              memberIds: [],
              roleId: '',
            };
            this.$refs.tree.setCheckedKeys([]);
            this.list();
          } else {
            utils.messageAlert(response.data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      } else {
        menuTabJs.edit(this.formModel).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogVisible = false;
            // utils.messageAlert(this.$t('msg_19'), this.$t('label_358'), this.$t('label_100'));
            this.$message.success(this.$t('msg_19'));
            this.formModel = {
              organizationId: '',
              roleName: "",
              duty: '',
              menuIds: [],
              menuNames: [],
              memberNames: [],
              memberIds: [],
              roleId: '',
            };
            this.$refs.tree.setCheckedKeys([]);
            this.list();
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      }
    },
    remove() {
      if (Object.keys(this.currentRow).length > 0) {
        this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          menuTabJs.remove({
            id: this.currentRow.roleId
          }).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              // utils.messageAlert(this.$t('msg_14'), this.$t('label_358'), this.$t('label_100'));
              this.$message.success(this.$t('msg_14'));
              this.list();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {

        });
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    //member
    member() {
      if (Object.keys(this.currentRow).length > 0) {
        this.formModel.roleId = this.currentRow.roleId;
        if (this.currentRow.memberIds != null) {
          this.formModel.memberIds = this.currentRow.memberIds.split(',');
          this.formModel.memberNames = this.currentRow.memberNames.split(',');
        }
        this.memberDialogVisible = true;
        this.inputValue = '';
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    memberDialogClose() {
      this.memberDialogVisible = false;
      this.formModel = {
        organizationId: '',
        roleName: "",
        duty: '',
        menuIds: [],
        menuNames: [],
        memberNames: [],
        memberIds: [],
        roleId: '',
      };
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    querySearchAsync(queryString, cb) {
      userJs.getByName({
        name: queryString
      }).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          cb(data.data.filter((el) => {
            return !this.formModel.memberIds.includes(el.id);
          }));
        }
      }).catch((response) => {
        console.log(response)
      });
    },
    handleSelect(item) {
      this.formModel.memberNames.push(item.fullName);
      this.formModel.memberIds.push(item.id);
      this.inputVisible = false;
      this.inputValue = '';
    },
    tagClose(name) {
      let index = this.formModel.memberNames.indexOf(name);
      this.formModel.memberNames.splice(index, 1);
      this.formModel.memberIds.splice(index, 1);
    },
    saveMember() {
      this.saveLoading = true;
      menuTabJs.updateMember(this.formModel).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.memberDialogVisible = false;
          // utils.messageAlert(this.$t('msg_19'), this.$t('label_358'), this.$t('label_100'));
          this.$message.success(this.$t('msg_19'));
          this.formModel = {
            organizationId: '',
            roleName: "",
            duty: '',
            menuIds: [],
            menuNames: [],
            memberNames: [],
            memberIds: [],
            roleId: '',
          };
          this.list();
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
        this.saveLoading = false;
      }).catch((response) => {
        this.saveLoading = false;
        console.log(response)
      })
    },
    //table
    tableCurrentChange(row) {
      this.currentRow = row;
    },
    formatRoleName(roleName) {
      let index = roleName.indexOf('/');
      if (index == -1) {
        return roleName;
      } else {
        return roleName.substr(index + 1);
      }
    },
    upDisabled(index) {
      if (this.expand || index == 0) {
        return true;
      } else {
        return false;
      }
    },
    downDisabled(index) {
      if (this.expand) {
        return true;
      }
      if (index === this.tableData.length - 1) return true;
      else return false;
    },
    nameClick(item) {
      this.viewModel.roleName = item.roleName;
      this.viewModel.duty = item.duty;
      if (item.menuIds != null) {
        this.viewModel.menuIds = item.menuIds.split(',');
      }
      organizationTabJs.getParent({
        id: this.nodeId
      }).then((response) => {
        if (response.data.code == 1) {
          this.parentName = response.data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      this.viewDialogVisible = true;
    },
    stateChange(item) {
      menuTabJs.updateState({
        id: item.roleId,
        state: item.state
      }).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.list();
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    moveUp(item, index) {
      menuTabJs.sort({
        id: item.roleId,
        sort: item.sequence,
        id2: this.tableData[index - 1].roleId,
        sort2: this.tableData[index - 1].sequence
      }).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.list();
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    moveDown(item, index) {
      menuTabJs.sort({
        id: item.roleId,
        sort: item.sequence,
        id2: this.tableData[index + 1].roleId,
        sort2: this.tableData[index + 1].sequence
      }).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.list();
        }
      }).catch((response) => {
        console.log(response)
      })
    },

    list() {
      utils.startLoading();
      menuTabJs.getByOrganization({
        organizationId: this.expand ? '' : this.nodeId,
        hierarchy: this.expand ? this.hierarchy : '',
      }).then((response) => {
        if (response.data.code == 1) {
          this.tableData = response.data.data;
        }
        utils.endLoading();
      }).catch((response) => {
        console.log(response);
        utils.endLoading();
      })
    },
    setNodeId(id, hierarchy) {
      this.nodeId = id;
      this.expandedKeys.push(this.nodeId);
      this.hierarchy = hierarchy;
      this.tableHeight = document.querySelector('.el-tabs__content').clientHeight - 34;
    },
    checkAllOrNotChange(row) {
      menuTabJs.updateCheckAllOrNot({
        id: row.roleId,
        flag: row.checkAllOrNot
      }).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error(res.data.message)
        }
      });
    },
    roleChangeHandle(data) {
      /*this.$nextTick(() => {
        if (data) {
          if (this.formModel.menuIds.indexOf('127') != -1 || this.formModel.menuIds.indexOf('157') != -1 ) {
            if (this.formModel.menuIds.indexOf('127') == -1) {
              this.formModel.menuIds.push('127')
            }
            if (this.formModel.menuIds.indexOf('157') == -1) {
              this.formModel.menuIds.push('157')
            }
          }
          if (this.formModel.menuIds.indexOf('128') != -1 || this.formModel.menuIds.indexOf('158') != -1 ) {
            if (this.formModel.menuIds.indexOf('128') == -1) {
              this.formModel.menuIds.push('128')
            }
            if (this.formModel.menuIds.indexOf('158') == -1) {
              this.formModel.menuIds.push('158')
            }
          }
          if (this.formModel.menuIds.indexOf('129') != -1 || this.formModel.menuIds.indexOf('159') != -1 ) {
            if (this.formModel.menuIds.indexOf('129') == -1) {
              this.formModel.menuIds.push('129')
            }
            if (this.formModel.menuIds.indexOf('159') == -1) {
              this.formModel.menuIds.push('159')
            }
          }
          if (this.formModel.menuIds.indexOf('130') != -1 || this.formModel.menuIds.indexOf('160') != -1 ) {
            if (this.formModel.menuIds.indexOf('130') == -1) {
              this.formModel.menuIds.push('130')
            }
            if (this.formModel.menuIds.indexOf('160') == -1) {
              this.formModel.menuIds.push('160')
            }
          }
          if (this.formModel.menuIds.indexOf('131') != -1 || this.formModel.menuIds.indexOf('161') != -1 ) {
            if (this.formModel.menuIds.indexOf('131') == -1) {
              this.formModel.menuIds.push('131')
            }
            if (this.formModel.menuIds.indexOf('161') == -1) {
              this.formModel.menuIds.push('161')
            }
          }
        } else {
          if (this.formModel.menuIds.indexOf('127') == -1 || this.formModel.menuIds.indexOf('157') == -1 ) {
            if (this.formModel.menuIds.indexOf('127') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '127')
            }
            if (this.formModel.menuIds.indexOf('157') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '157')
            }
          }
          if (this.formModel.menuIds.indexOf('128') == -1 || this.formModel.menuIds.indexOf('158') == -1 ) {
            if (this.formModel.menuIds.indexOf('128') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '128')
            }
            if (this.formModel.menuIds.indexOf('158') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '158')
            }
          }
          if (this.formModel.menuIds.indexOf('129') == -1 || this.formModel.menuIds.indexOf('159') == -1 ) {
            if (this.formModel.menuIds.indexOf('129') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '129')
            }
            if (this.formModel.menuIds.indexOf('159') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '159')
            }
          }
          if (this.formModel.menuIds.indexOf('130') == -1 || this.formModel.menuIds.indexOf('160') == -1 ) {
            if (this.formModel.menuIds.indexOf('130') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '130')
            }
            if (this.formModel.menuIds.indexOf('160') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '160')
            }
          }
          if (this.formModel.menuIds.indexOf('131') == -1 || this.formModel.menuIds.indexOf('161') == -1 ) {
            if (this.formModel.menuIds.indexOf('131') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '131')
            }
            if (this.formModel.menuIds.indexOf('161') != -1) {
              this.formModel.menuIds = this.formModel.menuIds.filter(item => item != '161')
            }
          }
        }
      });*/
    }
  },
  created() {
    this.MenuRoleList = this.$store.getters.getMenu;
    this.version = this.$store.getters.getVersions;
  },
  mounted() {
    menuTabJs.get().then((response) => {
      if (response.data.code == 1) {
        this.allMenus = response.data.data;
      }
    }).catch((response) => {
      console.log(response);
    })
  }
}
</script>
<style scoped>
.contactRow {
  height: 20px;
  margin-top: 3px;
  line-height: 20px;
  vertical-align: middle;
}

.contactRow img {
  height: 90%;
  line-height: 18px;
  vertical-align: middle;
}

.contactRow span {
  margin-left: 5px;
  line-height: 20px;
  vertical-align: middle;
}

.el-col {
  line-height: 40px;
}

/* viewDialog */
.viewDialogTable {
  margin-top: 10px;
  border: 1px solid #aaaaaa;
}

.viewDialogLabel {
  display: block;
  width: 100%;
  padding: 6px;
  border-bottom: 1px solid #aaaaaa;
  background-color: #ebebeb;
  font-weight: 600;
}

.viewDialogTable div {
  width: 100%;
  padding: 6px;
}

/* 权限 */
.menuName1 {
  display: block;
  width: 100%;
  border-top: 1px solid #c9c9c9;
}

[class^=menuName] {
  padding: 6px;
  line-height: 40px;
}

.folder0 {
  border-top-width: 0px !important;
}

.menuText1 {
  font-weight: 600;
}

.menuName2,
.menuName3 {
  display: inline-flex;
  width: 150px;
}

.menuName99 {
  margin-right: 20px;
}

.memberButton {
  background-image: linear-gradient(#0353c1, #0353c1);
  color: #ffffff;
  border: none;
}

.memberButton {
  background: #0353c1;
  color: #ffffff;
}

.checkAll {
  margin-left: 10px;
}
</style>
<style>
.viewDialogTable .el-checkbox__inner {
  background-color: #999999 !important;
  border-color: #999999 !important;
}

.viewDialogTable .el-checkbox__label {
  color: #999999 !important;
}

.viewDialogTable .el-checkbox__inner::after {
  border-color: #ffffff !important;
  border-width: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/menuTab.vue